import { render, staticRenderFns } from "./MemoruSetting.vue?vue&type=template&id=60276d92&"
import script from "./MemoruSetting.vue?vue&type=script&lang=ts&"
export * from "./MemoruSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports